import { Injectable } from '@angular/core';

import { Api } from './api.service';
import { Log } from '../utils/index';

@Injectable()
export class PushService {

  constructor(protected http: Api) {}

  @Log('green')
  send(entity: string, entityId: number, message: string, appli: boolean, mail: boolean, sms: boolean) {
    return this.http.post(`notification/${entity}/${entityId}/send`, { 'appli': appli, 'mail': mail, 'sms': sms, 'message': message });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/push.service.ts